import React from 'react';
import SEO from '../components/SEO';
import './VenueDetail.css';

function BridalRoom() {
  return (
    <div className="venue-detail-page">
      <SEO
        title="브라이덜 스위트 | Bridal Suite"
        description="신부 대기실 브라이덜 스위트. 프라이빗한 준비 공간에서 여유롭게 웨딩 준비."
        path="/venue/bridal-suite"
      />
      {/* Hero */}
      <section className="detail-hero">
        <div className="hero-image">
          <img src="/images/bridal-room/bridal-hero.jpg" alt="Bridal Suite" />
          <div className="hero-overlay">
            <div className="container">
              <div className="hero-content fade-in">
                <h1>Bridal Suite</h1>
                <p className="capacity-tag">Private Preparation Space</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Description */}
      <section className="detail-description">
        <div className="container">
          <div className="space-notice fade-in">
            <span className="notice-tag">📷 Season Preview</span>
          </div>
          <div className="description-content fade-in">
            <h2>Your Private Sanctuary</h2>
            <p>
              A dedicated space for the bride and bridal party to prepare,
              relax, and enjoy those precious moments before the ceremony.
            </p>
            <p>
              Natural light, elegant furnishings, and all the comfort
              you need to get ready in style.
            </p>
          </div>
        </div>
      </section>

      {/* Gallery */}
      <section className="detail-gallery">
        <div className="container-wide">
          <div className="gallery-grid fade-in">
            {[1, 2, 3, 4].map((num) => (
              <div key={num} className="gallery-item">
                <img 
                  src={`/images/bridal-room/bridal-${num}.jpg`}
                  alt={`Bridal Suite ${num}`}
                  onError={(e) => {
                    e.target.style.display = 'none';
                    e.target.parentElement.classList.add('placeholder');
                  }}
                />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Features */}
      <section className="detail-features">
        <div className="container">
          <div className="features-content fade-in">
            <h2>Amenities</h2>
            <div className="features-grid">
              <div className="feature-item">
                <h3>Full-Length Mirrors</h3>
                <p>Perfect lighting for final touches</p>
              </div>
              <div className="feature-item">
                <h3>Comfortable Seating</h3>
                <p>Lounge area for your party</p>
              </div>
              <div className="feature-item">
                <h3>Private Entrance</h3>
                <p>Direct access to ceremony space</p>
              </div>
              <div className="feature-item">
                <h3>Refreshments</h3>
                <p>Light refreshments available</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default BridalRoom;
